import React from 'react'
import { Circle, Path } from 'react-native-svg'
import type { BadgeArtProps } from './BadgePlaceholder'

const CHIP_RIM_SEGMENTS = [
  {
    d: 'M35.39,14.4s0,0,0,0c.49-.11.99-.21,1.49-.3.02,0,.04,0,.06-.01.46-.08.93-.15,1.4-.2.06,0,.12-.02.18-.02.43-.05.86-.08,1.3-.11.1,0,.19-.02.28-.02.51-.03,1.03-.05,1.55-.05h0c.52,0,1.04.02,1.55.05.1,0,.19.02.28.02.43.03.87.06,1.3.11.06,0,.12.02.18.02.47.06.94.12,1.4.2.02,0,.04,0,.06.01.5.09,1,.19,1.49.3,0,0,0,0,0,0V2.5c-.33-.05-.66-.09-.99-.14-.27-.04-.54-.07-.81-.1-.3-.03-.59-.06-.89-.09-.35-.03-.7-.06-1.05-.08-.24-.02-.47-.03-.71-.04-.6-.03-1.21-.05-1.82-.05s-1.22.02-1.82.05c-.24.01-.47.03-.71.04-.35.02-.7.05-1.05.08-.3.03-.59.06-.89.09-.27.03-.54.07-.82.1-.33.04-.66.09-.98.14,0,0,0,0,0,0v11.9Z',
    role: 'shade'
  },
  {
    d: 'M47.93,14.4s0,0,0,0c2.3.53,4.49,1.34,6.54,2.4.01,0,.02.01.04.02.68.35,1.34.73,1.99,1.14l8.4-8.4s0,0,0,0c-.6-.43-1.21-.85-1.83-1.25-.04-.03-.08-.05-.12-.08-.61-.39-1.23-.77-1.87-1.12-.02-.01-.04-.02-.06-.03-1.97-1.11-4.04-2.05-6.2-2.82-.08-.03-.16-.05-.24-.08-.62-.21-1.24-.41-1.87-.59-.13-.04-.26-.08-.4-.11-.6-.17-1.22-.32-1.83-.46-.12-.03-.24-.06-.37-.08-.73-.16-1.46-.3-2.2-.42v11.9Z',
    role: 'primary'
  },
  {
    d: 'M56.5,17.96c.44.27.86.56,1.28.86.02.02.05.03.07.05.41.29.81.6,1.21.91.01,0,.02.02.03.02,1.64,1.31,3.13,2.8,4.44,4.44,0,.01.02.02.03.03.31.39.62.8.91,1.21.02.02.03.05.05.07.3.42.58.85.86,1.28l8.4-8.4c-.61-.85-1.26-1.67-1.94-2.46,0,0-.02-.02-.02-.03-1.35-1.58-2.83-3.06-4.42-4.42,0,0-.02-.02-.03-.02-.79-.68-1.62-1.33-2.46-1.94,0,0,0,0,0,0l-8.4,8.4Z',
    role: 'shade'
  },
  {
    d: 'M65.37,26.83c.4.64.78,1.31,1.14,1.99,0,.01.01.03.02.04,1.06,2.05,1.87,4.24,2.4,6.54h11.9c-.12-.74-.26-1.47-.42-2.2-.03-.12-.06-.24-.08-.37-.14-.62-.3-1.23-.46-1.83-.04-.13-.07-.27-.11-.4-.18-.63-.38-1.25-.59-1.87-.03-.08-.05-.16-.08-.24-.76-2.16-1.71-4.23-2.82-6.21,0-.02-.02-.03-.03-.05-.36-.63-.73-1.26-1.12-1.87-.03-.04-.05-.08-.08-.12-.4-.62-.82-1.23-1.25-1.83l-8.4,8.4Z',
    role: 'primary'
  },
  {
    d: 'M68.92,35.39c.11.49.21.99.3,1.49,0,.02,0,.04.01.06.08.47.15.93.2,1.41,0,.06.02.12.02.18.05.43.09.87.11,1.31,0,.09.02.18.02.27.03.52.05,1.03.05,1.55s-.02,1.04-.05,1.55c0,.09-.01.18-.02.27-.03.44-.07.88-.11,1.31,0,.06-.02.12-.02.18-.06.47-.12.94-.2,1.41,0,.02,0,.04,0,.05-.09.5-.19,1-.3,1.5h11.9c.05-.33.09-.66.14-.99.04-.27.07-.54.1-.81.03-.3.06-.59.09-.89.03-.35.06-.7.08-1.05.02-.24.03-.47.04-.71.03-.6.05-1.21.05-1.82s-.02-1.22-.05-1.82c-.01-.24-.03-.47-.04-.71-.02-.35-.05-.7-.08-1.05-.03-.3-.06-.6-.09-.89-.03-.27-.07-.54-.1-.81-.04-.33-.09-.66-.14-.99h-11.9Z',
    role: 'shade'
  },
  {
    d: 'M75.1,62.95c.39-.61.76-1.23,1.12-1.86.01-.02.02-.04.03-.06,1.11-1.97,2.05-4.04,2.81-6.2.03-.08.05-.16.08-.24.21-.62.41-1.24.59-1.87.04-.13.08-.27.11-.4.17-.6.32-1.22.46-1.83.03-.12.06-.24.08-.37.16-.73.3-1.46.42-2.2,0,0,0,0,0,0h-11.9c-.53,2.3-1.34,4.49-2.4,6.54,0,.01-.01.02-.02.04-.35.68-.73,1.34-1.14,1.99l8.4,8.41s0,0,0,0c.43-.6.85-1.2,1.25-1.82.03-.04.05-.08.08-.12Z',
    role: 'primary'
  },
  {
    d: 'M65.37,56.5c-.27.44-.56.86-.86,1.28-.02.02-.03.05-.05.07-.29.41-.6.81-.91,1.21,0,0-.01.02-.02.03-1.31,1.64-2.8,3.13-4.44,4.44-.01,0-.02.02-.03.03-.39.31-.8.62-1.21.91-.02.02-.05.03-.07.05-.42.3-.85.58-1.28.86l8.41,8.4c.85-.61,1.67-1.26,2.46-1.94,0,0,.02-.02.03-.02,1.58-1.35,3.06-2.83,4.42-4.42,0,0,.01-.02.02-.03.68-.79,1.33-1.62,1.94-2.46,0,0,0,0,0,0l-8.4-8.41Z',
    role: 'shade'
  },
  {
    d: 'M56.5,65.37c-.64.4-1.31.78-1.99,1.14-.01,0-.03.01-.04.02-2.05,1.06-4.24,1.87-6.54,2.4,0,0,0,0,0,0v11.9c.74-.12,1.47-.26,2.2-.42.12-.03.24-.06.36-.08.62-.14,1.23-.3,1.83-.47.13-.04.26-.07.4-.11.63-.18,1.25-.38,1.87-.59.08-.03.16-.05.24-.08,2.16-.76,4.23-1.71,6.2-2.82.02,0,.03-.02.05-.03.63-.36,1.26-.73,1.87-1.13.04-.02.08-.05.12-.07.62-.4,1.23-.82,1.83-1.25l-8.41-8.4Z',
    role: 'primary'
  },
  {
    d: 'M47.93,68.92s0,0,0,0c-.49.11-.99.21-1.49.3-.02,0-.04,0-.06.01-.46.08-.93.15-1.4.2-.06,0-.12.02-.19.02-.43.05-.86.08-1.3.11-.09,0-.19.02-.28.02-.51.03-1.03.05-1.55.05h0c-.52,0-1.04-.02-1.55-.05-.09,0-.19-.02-.28-.02-.44-.03-.87-.07-1.3-.11-.06,0-.12-.02-.19-.02-.47-.06-.94-.12-1.4-.2-.02,0-.04,0-.06-.01-.5-.09-1-.19-1.49-.3,0,0,0,0,0,0v11.9s0,0,0,0c.33.05.66.09.98.14.27.04.54.07.82.1.3.03.59.06.89.09.35.03.7.06,1.05.08.24.02.47.03.71.04.6.03,1.21.05,1.82.05s1.22-.02,1.82-.05c.24-.01.47-.03.71-.04.35-.02.7-.05,1.05-.08.3-.03.6-.06.89-.09.27-.03.54-.07.81-.1.33-.04.66-.09.99-.14v-11.9Z',
    role: 'shade'
  },
  {
    d: 'M35.39,68.92s0,0,0,0c-2.3-.53-4.49-1.34-6.54-2.4-.01,0-.03-.01-.04-.02-.68-.35-1.34-.73-1.98-1.13,0,0,0,0,0,0l-8.4,8.4c.6.43,1.21.85,1.83,1.25.04.03.08.05.12.08.61.39,1.23.77,1.87,1.12.02.01.04.02.05.03,1.97,1.11,4.04,2.05,6.2,2.82.08.03.16.05.24.08.62.21,1.24.41,1.87.59.13.04.26.08.4.11.6.17,1.22.32,1.83.46.12.03.24.06.37.09.72.16,1.46.3,2.19.42,0,0,0,0,0,0v-11.9Z',
    role: 'primary'
  },
  {
    d: 'M26.83,65.37s0,0,0,0c-.43-.27-.86-.56-1.28-.85-.03-.02-.05-.04-.08-.06-.41-.29-.81-.59-1.2-.9-.01,0-.02-.02-.04-.03-1.64-1.31-3.12-2.8-4.43-4.43,0-.01-.02-.02-.03-.04-.31-.39-.61-.79-.9-1.2-.02-.02-.04-.05-.05-.07-.3-.42-.58-.84-.85-1.28,0,0,0,0,0,0l-8.4,8.4c.61.85,1.26,1.67,1.94,2.46,0,0,.02.02.02.03,1.35,1.58,2.83,3.06,4.42,4.42,0,0,.02.01.03.02.79.68,1.62,1.33,2.46,1.94l8.4-8.4Z',
    role: 'shade'
  },
  {
    d: 'M17.96,56.5s0,0,0,0c-.4-.64-.78-1.31-1.13-1.98,0-.01-.01-.03-.02-.04-1.06-2.05-1.87-4.24-2.4-6.54,0,0,0,0,0,0H2.5s0,0,0,0c.12.74.26,1.47.42,2.2.03.12.06.24.08.36.14.62.3,1.23.46,1.83.04.13.07.27.11.4.18.63.38,1.25.59,1.87.03.08.05.16.08.24.76,2.16,1.71,4.23,2.81,6.2.01.02.02.04.03.06.36.63.73,1.25,1.12,1.86.03.04.05.08.08.12.4.62.82,1.23,1.25,1.83l8.4-8.4Z',
    role: 'primary'
  },
  {
    d: 'M14.4,47.93s0,0,0,0c-.11-.49-.21-.99-.3-1.49,0-.02,0-.04-.01-.06-.08-.46-.15-.93-.2-1.4,0-.06-.02-.13-.02-.19-.05-.43-.08-.86-.11-1.29,0-.1-.02-.19-.02-.29-.03-.51-.04-1.02-.04-1.54,0,0,0-.01,0-.02s0-.01,0-.02c0-.52.02-1.03.04-1.53,0-.1.02-.19.02-.29.03-.43.06-.86.11-1.29,0-.06.02-.13.02-.19.06-.47.12-.94.2-1.4,0-.02,0-.04.01-.06.09-.5.19-1,.3-1.49,0,0,0,0,0,0H2.5c-.05.33-.09.66-.14.99-.04.27-.07.54-.1.81-.03.3-.06.59-.09.89-.03.35-.06.7-.08,1.05-.02.24-.03.47-.04.71-.03.6-.05,1.21-.05,1.82s.02,1.22.05,1.82c.01.24.03.47.04.71.02.35.05.7.08,1.05.03.3.06.59.09.89.03.27.07.54.1.81.04.33.09.66.14.99h0s11.9,0,11.9,0Z',
    role: 'shade'
  },
  {
    d: 'M14.4,35.39s0,0,0,0c.53-2.3,1.34-4.49,2.4-6.54,0-.01.01-.03.02-.04.35-.68.73-1.34,1.13-1.98,0,0,0,0,0,0l-8.4-8.4s0,0,0,0c-.43.6-.85,1.21-1.25,1.83-.03.04-.05.08-.08.12-.39.61-.77,1.23-1.12,1.86-.01.02-.02.04-.03.06-1.11,1.97-2.05,4.04-2.82,6.2-.03.08-.05.16-.08.24-.21.62-.41,1.24-.59,1.87-.04.13-.08.26-.11.4-.17.61-.32,1.22-.47,1.83-.03.12-.06.24-.08.36-.16.73-.3,1.46-.42,2.2h0s11.9,0,11.9,0Z',
    role: 'primary'
  },
  {
    d: 'M17.96,26.83s0,0,0,0c.27-.44.56-.86.86-1.28.02-.02.04-.05.05-.07.29-.41.59-.81.91-1.2,0-.01.02-.02.03-.04,1.31-1.64,2.8-3.13,4.43-4.43.01,0,.02-.02.03-.03.39-.31.79-.61,1.2-.91.03-.02.05-.04.08-.05.42-.3.84-.58,1.28-.85,0,0,0,0,0,0l-8.4-8.4h0c-.85.61-1.67,1.26-2.46,1.94,0,0-.02.02-.03.02-1.58,1.35-3.06,2.83-4.42,4.42,0,0-.02.02-.02.03-.68.79-1.33,1.62-1.94,2.46,0,0,0,0,0,0l8.4,8.4Z',
    role: 'shade'
  },
  {
    d: 'M26.83,17.96s0,0,0,0c.64-.4,1.31-.78,1.98-1.13.01,0,.03-.01.04-.02,2.05-1.06,4.24-1.87,6.54-2.4,0,0,0,0,0,0V2.5s0,0,0,0c-.74.12-1.47.26-2.19.42-.12.03-.24.06-.37.08-.62.14-1.23.3-1.83.46-.13.04-.26.07-.4.11-.63.18-1.25.38-1.87.59-.08.03-.16.05-.24.08-2.16.76-4.23,1.71-6.2,2.81-.02.01-.04.02-.06.03-.63.36-1.25.73-1.86,1.12-.04.03-.08.05-.12.08-.62.4-1.23.82-1.83,1.25h0s8.4,8.4,8.4,8.4Z',
    role: 'primary'
  }
] as const

// Clockwise progress order, beginning one segment clockwise of 12 o'clock.
// Each edge uses the exact inner/outer boundary points from the designer's
// adjoining chip paths, avoiding calculated rotations and radius drift.
const CHIP_RIM_PROGRESS_SEGMENTS = [
  { segment: CHIP_RIM_SEGMENTS[1], leadingEdge: 'M56.5 17.96L64.9 9.56' },
  { segment: CHIP_RIM_SEGMENTS[2], leadingEdge: 'M65.37 26.83L73.77 18.43' },
  { segment: CHIP_RIM_SEGMENTS[3], leadingEdge: 'M68.92 35.39L80.82 35.39' },
  { segment: CHIP_RIM_SEGMENTS[4], leadingEdge: 'M68.92 47.93L80.82 47.93' },
  { segment: CHIP_RIM_SEGMENTS[5], leadingEdge: 'M65.37 56.5L73.77 64.9' },
  { segment: CHIP_RIM_SEGMENTS[6], leadingEdge: 'M56.5 65.37L64.9 73.77' },
  { segment: CHIP_RIM_SEGMENTS[7], leadingEdge: 'M47.93 68.92L47.93 80.82' },
  { segment: CHIP_RIM_SEGMENTS[8], leadingEdge: 'M35.39 68.92L35.39 80.82' },
  { segment: CHIP_RIM_SEGMENTS[9], leadingEdge: 'M26.83 65.37L18.43 73.77' },
  { segment: CHIP_RIM_SEGMENTS[10], leadingEdge: 'M17.96 56.5L9.56 64.9' },
  { segment: CHIP_RIM_SEGMENTS[11], leadingEdge: 'M14.4 47.93L2.5 47.93' },
  { segment: CHIP_RIM_SEGMENTS[12], leadingEdge: 'M14.4 35.39L2.5 35.39' },
  { segment: CHIP_RIM_SEGMENTS[13], leadingEdge: 'M17.96 26.83L9.56 18.43' },
  { segment: CHIP_RIM_SEGMENTS[14], leadingEdge: 'M26.83 17.96L18.43 9.56' },
  { segment: CHIP_RIM_SEGMENTS[15], leadingEdge: 'M35.39 14.4L35.39 2.5' },
  { segment: CHIP_RIM_SEGMENTS[0], leadingEdge: 'M47.93 14.4L47.93 2.5' }
] as const

/**
 * The canonical 16-segment poker-chip rim shared by designer chip badges.
 * It owns next-tier progress so every converted asset has identical geometry,
 * orientation, and segment behavior.
 */
export const BadgeChipRim: React.FC<Pick<BadgeArtProps, 'palette' | 'nextPalette' | 'progressToNextTier'>> = ({
  palette,
  nextPalette,
  progressToNextTier
}) => {
  const filledSegmentCount =
    nextPalette && progressToNextTier !== null && progressToNextTier !== undefined
      ? Math.floor(Math.min(1, Math.max(0, progressToNextTier)) * CHIP_RIM_SEGMENTS.length)
      : 0

  const hasProgress = filledSegmentCount > 0
  // Pull the progress circle toward the center so the thinner highlight hugs
  // the inside edge of the chip rim instead of floating across its segments.
  // Its end stops short of the next boundary to avoid bleeding into the first
  // unfilled piece.
  const progressRadius = 28
  const progressShadowRadius = progressRadius + 1.1
  const progressRatio = filledSegmentCount / CHIP_RIM_SEGMENTS.length
  const progressCircumference = 2 * Math.PI * progressRadius
  const progressShadowCircumference = 2 * Math.PI * progressShadowRadius
  const progressLength = Math.max(0, progressCircumference * progressRatio - 0.25)
  const progressShadowLength = Math.max(0, progressShadowCircumference * progressRatio - 0.25)
  const leadingEdge =
    filledSegmentCount > 0 && filledSegmentCount < CHIP_RIM_SEGMENTS.length
      ? CHIP_RIM_PROGRESS_SEGMENTS[filledSegmentCount - 1].leadingEdge
      : null

  return (
    <>
      {CHIP_RIM_PROGRESS_SEGMENTS.map(({ segment: { d, role } }, progressPosition) => {
        const isFilled = progressPosition < filledSegmentCount
        return <Path key={d} d={d} fill={isFilled ? (nextPalette?.[role] ?? palette[role]) : palette[role]} />
      })}
      {leadingEdge ? (
        <Path
          d={leadingEdge}
          fill="none"
          stroke="#000"
          strokeOpacity={0.1}
          strokeWidth={2}
          strokeLinecap="butt"
          // One degree at the outer rim is approximately one rendered pixel.
          // Rotate backward so the shadow sits inside the filled segment.
          transform="rotate(-1 41.66 41.66)"
        />
      ) : null}
      {leadingEdge ? (
        <Path
          d={'M47.93 14.4L47.93 2.5'}
          fill="none"
          stroke="#000"
          strokeOpacity={0.1}
          strokeWidth={2}
          strokeLinecap="butt"
          // One degree at the outer rim is approximately one rendered pixel.
          // Rotate backward so the shadow sits inside the filled segment.
          transform="rotate(1 41.66 41.66)"
        />
      ) : null}
      {/* SVG paints later siblings on top. Keep both progress circles after
          the segment-edge shadow so the circles always remain in front of it. */}
      {hasProgress ? (
        <>
          <Circle
            cx={41.66}
            cy={41.66}
            r={progressShadowRadius}
            fill="none"
            stroke="#333"
            strokeOpacity={0.3}
            strokeWidth={3}
            strokeDasharray={`${progressShadowLength} ${progressShadowCircumference - progressShadowLength}`}
            strokeLinecap="butt"
            transform="rotate(-78 41.66 41.66)"
          />
          <Circle
            cx={41.66}
            cy={41.66}
            r={progressRadius}
            fill="none"
            stroke="#fff"
            strokeOpacity={0.1}
            strokeWidth={1.2}
            strokeDasharray={`${progressLength} ${progressCircumference - progressLength}`}
            strokeLinecap="butt"
            transform="rotate(-78 41.66 41.66)"
          />
        </>
      ) : null}
    </>
  )
}
